<template>
  <div >
          <transition name="fade">
             <div class="popup-modal" v-if="isVisible">
                 <div class="window">
                    <slot></slot>
                 </div>
            </div>
          </transition>
  </div>
</template>


<style scoped>
.fade-enter-active,
.fade-leave-active {
   transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
   opacity: 0;
}

.popup-modal {
   background-color: rgba(0,0,0,0.5);
   position: fixed;
   top: 0;
   bottom: 0;
   left: 0;
   right: 0;
   padding: 0.1rem;
   display: flex;
   align-items: center;
   z-index: 1;
}

.window {
   background: #fff;
   border-radius: 5px;
   box-shadow: 2px 4pxx 8px rgba(0,0,0,0.2);
   max-width: 520px;
   min-width:250px;
   margin-left: auto;
   margin-right: auto;
   padding: 0.2rem;
}
</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import callingApiCenter from "./CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
  import api from '../api';

    import dateFormat from '../utils/dateFormat';

    

  const getInitialdataForm = () => ({
    mode: null,
    appName: null,
    ver: null,
    env: null,
    status: null,
    releaseDate: null,
    releaseNote: null,
  });

 

  export default {
    name: 'PopupModal',
    data: () => ({
       isVisible: false,      
    }),

    methods: {
      open() {
        this.isVisible = true
      },
      close() {
        this.isVisible = false
      }
    },
  };
</script>
